import {
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit';
import {v4 as uid} from 'uuid';

import {getMapOfValues} from 'shared/utils';

import {MENU_SLICE} from './menu-slice-constants';
import {loadMenuStructure} from './menu-slice-thunks';
import {
    IMenuSliceState, TMenuStructure, IMenuStructureItem,
} from './menu-slice-types';

export const menuSlice = createSlice({
    initialState: {
        selectedMenusIds: [],

        isMenuOpen: false,
        searchLine: undefined,

        structure: null,
        structureIdMap: null,

        meta: {
            openId: undefined,
        },
    } as IMenuSliceState,
    name: MENU_SLICE,
    reducers: {
        setSearchLine(state, {payload}: PayloadAction<string | undefined>) {
            state.searchLine = payload;
        },
        setSelectedMenuItemsIds(state, {payload}: PayloadAction<string[]>) {
            state.selectedMenusIds = payload;
        },
        insertSelectedMenuItemAtIndex: (state, action: PayloadAction<{id: string; index: number}>) => {
            const {id, index} = action.payload;

            if (index < 0 || index > state.selectedMenusIds.length) {
                console.error('Ошибка в редьюсере "insertSelectedMenuItemAtIndex" передан неверный индекс:', index);
                return;
            }

            const isInsertingSameId = state.selectedMenusIds[index] === id;

            // копируем все значения до index
            const newSelectedMenus = state.selectedMenusIds.slice(0, index);

            // если по нужному индексу пытаемся добавить тот же элемент, что был там раньше, возвращаем массив без него
            // (технически это значит, что пользователь скрывает раскрытый пункт меню)
            state.selectedMenusIds = isInsertingSameId
                ? newSelectedMenus
                : [...newSelectedMenus, id];
        },
        setIsMenuOpen(state, {payload}: PayloadAction<boolean>) {
            state.isMenuOpen = payload;
            if (payload) state.meta.openId = uid();
        },
        setMenuData(state, {payload}: PayloadAction<TMenuStructure>) {
            state.structure = payload;
            state.structureIdMap = getMapOfValues<IMenuStructureItem>(payload);
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMenuStructure.fulfilled, (state, {payload: structure}) => {
            const structureWithChildren = structure.map(item => {
                const children = structure.filter(child => child.parentId === item.id);
                return {
                    ...item,
                    children,
                };
            }) as IMenuStructureItem[];

            state.structure = structureWithChildren;
            state.structureIdMap = getMapOfValues<IMenuStructureItem>(structureWithChildren);
        });
    },
});

export const {
    reducer: menuSliceReducer,
    actions: menuSliceActions,
} = menuSlice;
